import View from './base';

export default View.extend( {
	events: {
		'click .-toggle': 'toggle',
		'input .-toggle': 'toggle',
	},

	initialize: function( options = {} ) {
		View.prototype.initialize.apply( this, arguments );

		this.isDisabled = Boolean( options.disabled );
		this.isChecked = Boolean( options.checked );

		this.on( 'select unselect', this.renderStatus );
	},

	render: function() {
		View.prototype.render.apply( this, arguments );

		this.renderStatus();

		return this;
	},

	renderStatus: function() {
		this.$el.toggleClass( 'selected', this.isChecked );
		this.$( 'input.-toggle' ).prop( 'checked', this.isChecked );

		return this;
	},

	toggle: function( e ) {
		// Abort if disabled
		if ( this.isDisabled ) {
			return this;
		}

		var tagName = e && e.currentTarget.tagName.toLowerCase() || '';

		this.isChecked = ! this.isChecked;
		if ( tagName === 'input' ) {
			this.isChecked = e.currentTarget.checked;
		}

		this.trigger( this.isChecked ? 'select' : 'unselect' );

		return this;
	},

	select: function() {
		// Abort if disabled
		if ( this.isDisabled ) {
			return this;
		}

		this.isChecked = true;
		this.trigger( 'select' );

		return this;
	},

	unselect: function() {
		// Abort if disabled
		if ( this.isDisabled ) {
			return this;
		}

		this.isChecked = false;
		this.trigger( 'unselect' );

		return this;
	},

	setDisabled: function( disabled ) {
		this.isDisabled = disabled;
		this.$el.toggleClass( 'disabled', disabled );
		this.$( '.-toggle' ).attr( 'disabled', disabled );
	},
} );
